import type { ComponentProps } from "react";
import Link from "next/link";
import { cn } from "@/lib/utils";

type ArticleTagProps = {
  label: string;
  linked?: boolean;
  /** Wie bei EventTag: sand fuer kostenlos, sun fuer Member-Only. */
  memberOnly?: boolean;
} & ComponentProps<"span">;

const ArticleTag = ({ label, linked = true, memberOnly = false, className, ...rest }: ArticleTagProps) => {
  const tag = (
    <span
      className={cn(
        // Gleiche Schrift wie EventTag, damit Artikel- und Event-Karten zusammenpassen.
        "text-tag text-black-80 px-2 py-1 rounded-full",
        memberOnly ? "bg-sun-50" : "bg-sand-10",
        linked && "transition-colors cursor-pointer",
        linked && (memberOnly ? "hover:bg-sun-75" : "hover:bg-sand-50"),
        className
      )}
      {...rest}
    >
      {label}
    </span>
  );

  if (linked) {
    return (
      <Link href={`/search?tag=${encodeURIComponent(label)}`}>
        {tag}
      </Link>
    );
  }

  return tag;
};

export { ArticleTag };
export type { ArticleTagProps };
